<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Video:
          <br />
          <span class="disclaimer">YouTube links only. Allowed formats:</span>
          <br />
          <span class="disclaimer"
            >9:16 vertical&nbsp;&nbsp; &ndash; 1080x1920</span
          >
          <br />
          <span class="disclaimer">16:9 horizontal &ndash; 1920x1080</span>
          <br />
          <span class="disclaimer"
            >1:1&nbsp; square&nbsp;&nbsp;&nbsp;&nbsp; &ndash; 1080x1080</span
          >
          <br />
          <span class="disclaimer">Format: .MPG (MPEG-2 or MPEG-4)</span>
          <br />
          <span class="disclaimer">File size: &le;256 GB</span>
          <br />
          <span class="disclaimer">Minimum length: 10 seconds</span>
          <br />
          <span class="disclaimer">
            Length, file size and encoding still cannot be checked from a link,
            confirm those before publishing.
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [type]="'link'"
            [isPlainText]="true"
            (handleOnChange)="onChange($event, 'YoutubeVideoUrl')"
            [blockData]="block.variables?.['YoutubeVideoUrl'] ?? ''"
            [maxLength]="4000"
            [placeholder]="videoPlaceholder"
            variable="YoutubeVideoUrl"
            [blockId]="block.blockId"
          ></app-block-text>

          <!-- START: Thumbnail + measured format -->
          <div class="mb-3" *ngIf="hasVideo()">
            <img
              *ngIf="thumbnail()"
              class="video-thumbnail"
              [src]="thumbnail()"
              [style.aspect-ratio]="rowAspectRatio()"
              alt="YouTube video thumbnail"
            />
            <div class="video-format" *ngIf="formatLabel()">
              Format: {{ formatLabel() }}
            </div>
            <div
              class="video-format video-format-warning"
              *ngIf="formatWarning()"
            >
              <i class="bi bi-exclamation-triangle-fill"></i>
              {{ formatWarning() }}
            </div>
          </div>
          <!-- END: Thumbnail + measured format -->
        </div>
      </div>
    </div>
  </div>
</main>
